<template>
  <article
    v-if="currentPage && currentPage.protection.locked === false"
    class="single-post"
    id="post-page"
  >
    <PageHeader />
    <wpImage
      v-if="currentPage.featured_image_src"
      :data="currentPage.featured_image_src"
      size="extra_large"
      class="page-featuredimage animate-delay-03"
      lazy
      background
      placeholder
      data-key="1"
      v-observe-visibility="visibilityChanged"
      :class="[baseAnimation]"
    />
    <main class="post-content content-two-row">
      <div class="content">
        <DynamicHtml
          class="padding_large"
          v-observe-visibility="visibilityChanged"
          :class="[baseAnimation]"
          role="content"
          >{{ currentPage.content.rendered }}</DynamicHtml
        >
        <RelatedEvent
          class="related-event padding_large"
          v-if="currentPage.acf && currentPage.acf.select_event"
          :id="currentPage.acf.select_event"
        />
      </div>
      <aside class="sidebar padding_large">
        <div
          v-if="
            currentPage.featured_image_src &&
              currentPage.featured_image_src.caption
          "
          class="img-description"
          v-observe-visibility="visibilityChanged"
          :class="[baseAnimation]"
        >
          {{ currentPage.featured_image_src.caption }}
        </div>

        <Author
          :id="Number(currentPage.author)"
          v-observe-visibility="visibilityChanged"
          :class="[baseAnimation]"
        />
        <Categories
          v-if="currentPage.acf && currentPage.acf._categories"
          v-observe-visibility="visibilityChanged"
          :class="[baseAnimation]"
          :categories="currentPage.acf._categories"
        />
        <Share
          v-observe-visibility="visibilityChanged"
          :class="[baseAnimation]"
        />
      </aside>
    </main>
    <RelatedPosts :data="relatedPostsData" />
  </article>
  <PassProtected
    v-else-if="currentPage && currentPage.protection.locked === true"
  >
  </PassProtected>
</template>

<script>
import WpImage from "@/components/elements/WpImage";
import Author from "@/components/blocks/AuthorBlock";
import Share from "@/components/blocks/ShareBlock";
import RelatedEvent from "@/components/blocks/SingleEvent";
import Categories from "@/components/blocks/CategoriesBlock";
import RelatedPosts from "@/components/modules/News";

export default {
  name: "single-post",
  components: {
    WpImage,
    Author,
    Share,
    Categories,
    RelatedEvent,
    RelatedPosts
  },
  data() {
    return {
      isVisibleItem: {
        image: false,
        content: false
      }
    };
  },
  computed: {
    relatedPostsData() {
      return {
        news_category: this.currentPage.acf._categories,
        theme: "white",
        title: "Relaterte artikler"
      };
    }
  }
};
</script>

<style lang="scss">
@import "./../assets/scss/mixins.scss";
@import "./../assets/scss/vars.scss";

.related-event {
  @include mquery(1550px) {
    .event-footer {
      .column {
        max-width: 50%;
        width: 100%;
        padding: 20px;
      }
    }
    .event-block-link {
      display: flex;
      flex-direction: column;
      position: relative;
      justify-content: space-between;
      height: 100%;
      background: rgba(42, 46, 52, 1);
      padding-bottom: 0;
      text-decoration: none;
      transition: box-shadow 0.12s ease-in-out;
      &:hover {
        box-shadow: 0 0 10px 0 rgba(74, 79, 85, 0.5);
      }
      .event-thumb {
        padding-bottom: 56.25%;
        position: relative;
        .bg-image {
          padding-bottom: 56.25%;
        }
      }
      .event-footer {
        display: flex;
        position: relative;
        .left {
          max-width: 50%;
        }
        .right {
          display: flex;
          justify-content: flex-end;
          align-items: flex-end;
          max-width: 50%;
        }
      }
    }
  }
}
</style>
